// @core/api/endpoints/team/update_role_schedule.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  UpdateRoleScheduleRequest,
} from '../../../types/team';

const BASE_PATH = '/team';

/**
 * Update role schedule
 * Updates an existing role schedule with the provided data. Returns the updated resource.
 */
export async function UpdateRoleSchedule(
  team_id: string,
  schedule_id: string,
  data: UpdateRoleScheduleRequest,
  options?: RequestOptions
): Promise<Response> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/:team_id/schedules/:schedule_id`;
  requestPath = requestPath.replace(':team_id', encodeURIComponent(team_id));
  requestPath = requestPath.replace(':schedule_id', encodeURIComponent(schedule_id));
  const requestOptions = options;
  return client.put<Response>(requestPath, data, requestOptions);
}
